export var IMAGE_FILE_TYPES = ['jpg', 'png', 'ico'];
export var DOC_FILE_TYPES = ['doc', 'docx', 'pdf'];
export var UNIT_MB = 2;
export function fileSize(file, unit) {
    if (unit === void 0) { unit = 0; }
    if (!file) {
        return;
    }
    return file.size / Math.pow(1000, unit);
}
export function fileType(file) {
    if (!file) {
        return;
    }
    return file.name.split('.').pop();
}
